import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UIRouterGlobals } from "@uirouter/angular";
import { EventService } from "../../event-service/event.service";
import { ProjectService } from "../../models/project.service";
import { TrackerService } from "../../tracker/tracker.service";
import { InstructionsModalComponent } from "./instructions-modal.component";

@Injectable()
export class InstructionsModalService {
  constructor(
    private eventService: EventService,
    private projectService: ProjectService,
    private trackerService: TrackerService,
    private $uiRouterGlobals: UIRouterGlobals,
    public modalService: NgbModal,
  ) {}

  public open() {
    this.eventService.publish("show-install-airbrake-btn", false);

    const projectId = this.$uiRouterGlobals.params.projectId;
    this.projectService.get({ projectId }).subscribe((project: any) => {
      const modalRef = this.modalService.open(InstructionsModalComponent, {
        backdropClass: "modal-backdrop__semi-transparent",
        size: "xl",
      });
      modalRef.componentInstance.project = project;
      modalRef.dismissed.subscribe(() => {
        this.trackerService.track("installInstructionsModalDismissed");
        this.eventService.publish("show-install-airbrake-btn", true);
      });
    });
  }
}
